  function mobilenav_height() {
    if(jQuery('#shopify-section-bf_topbar').length != 0){
      let height = jQuery('#shopify-section-bf_topbar').height();
      let fromTop = jQuery(window).scrollTop();
      if(fromTop > height){
        jQuery('#mobilenav-main').css('top', 0);
        jQuery('#mobilenav-main').css('height', '100vh');      
      }else{
        jQuery('#mobilenav-main').css('top', height);
        jQuery('#mobilenav-main').css('height', `calc(100vh - ${height}px)`);
      }
    }
    
  }

function owl_card_list_slider() {
  let windowWidth = jQuery(window).width();
  let target = jQuery('.owl-card-list-grid')
  if(windowWidth < 768){
    target.addClass('owl-card-list-slider');
    target.addClass('owl-carousel');
    target.addClass('owl-theme');
    target.owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 1,
        animateOut: 'fadeOut',
        autoplay:true,
    	autoplayTimeout: 5000,
    	autoplayHoverPause:true,
    });
  }else{
    target.removeClass('owl-card-list-slider');
    target.removeClass('owl-carousel');
    target.removeClass('owl-theme');
    target.owlCarousel('destroy')   
  }
}
function owl_card_info_slider() {
  let windowWidth = jQuery(window).width();
  let target = jQuery('.owl-blog-list-grid')
  if(windowWidth < 768){
    target.addClass('owl-blog-list-slider');
    target.addClass('owl-carousel');
    target.addClass('owl-theme');
    target.owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 1,
        animateOut: 'fadeOut',
        autoplay:true,
    	autoplayTimeout: 5000,
    	autoplayHoverPause:true,
    });
  }else{
    target.removeClass('owl-blog-list-slider');
    target.removeClass('owl-carousel');
    target.removeClass('owl-theme');
    target.owlCarousel('destroy')   
  }
}




$(document).ready(function () {
    mobilenav_height();
    owl_card_list_slider();
    owl_card_info_slider();


    jQuery('.owl-add-to-cart-btn').click(function(e){
      $('#mini-cart').attr('open', 'open');
    })
  
    jQuery('.owl-footer-title .owl-footer-toggle').click(function(){
        jQuery(this).toggleClass('active');
        jQuery(this).parent().next().slideToggle();
    })

    jQuery('.owl-seo-content-bottom-title').click(function(){
        jQuery(this).toggleClass('active');
        jQuery(this).find('.owl-seo-content-bottom-toggle').toggleClass('active');
        jQuery(this).next().slideToggle();
    })  

    jQuery('.owl-testimonials-slider').owlCarousel({
        loop: true,
        margin: 19,
        nav: false,
        dots: true,
        items: 3,
        slideBy: 1,
        animateOut: 'fadeOut',
        autoplay:true,
    	autoplayTimeout: 5000,
    	autoplayHoverPause:true,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:2
            },
            1200:{
                items:3
            }
        }      
    });
    
    // if (window.location.pathname == '/') {
    //   jQuery('.owl-products-grid').owlCarousel({
    //       loop: true,
    //       margin: 19,
    //       nav: false,
    //       dots: true,
    //       items: 3,
    //       slideBy: 1,
    //       animateOut: 'fadeOut',
    //       responsive:{
    //           0:{
    //               items:1
    //           },
    //            450: {
    //             items: 1
    //           },
    //           768:{
    //               items: 2
    //           },
    //           1200:{
    //               items:3
    //           }
    //       }      
    //   });
    // }
    


    jQuery('[data-toggle="owl-dropdown"]').click(function(){
        jQuery(this).next('.owl-dropdown-menu').toggleClass('active');
        jQuery(this).toggleClass('active');
    })
    //Mobile menu new
    function toogle_mobilenav(n) {
        if (n == 'hide') {
            jQuery('body').removeClass('mobilenav-show');
            jQuery('body').removeClass('overflow_hidden');
            mobilenav_height();
        } else if (n == 'show') {
            jQuery('body').removeClass('mobilenav-show');
            jQuery('body').removeClass('overflow_hidden');
            mobilenav_height();
        } else {
            jQuery('body').toggleClass('mobilenav-show');
            jQuery('body').toggleClass('overflow_hidden');
            mobilenav_height();
        }
    }

    jQuery('.bf_navbar_toggler,.mobilenav-close').click(function(e) {
        e.preventDefault();
        toogle_mobilenav();
    });
    jQuery(document).mouseup(function(e) {
        var container = jQuery("#mobilenav-main");
        if (container.is(":visible")) {
            if (!container.is(e.target) // if the target of the click isn't the container...
                &&
                container.has(e.target).length === 0) // ... nor a descendant of the container
            {
                toogle_mobilenav('hide');
            }
        }


        let owl_dropdown = jQuery(".owl-dropdown");
        if (owl_dropdown.find('.owl-dropdown-menu').is(":visible")) {
            if (!owl_dropdown.is(e.target)  && owl_dropdown.has(e.target).length === 0)
            {
                owl_dropdown.find('[data-toggle="owl-dropdown"]').removeClass('active');
                owl_dropdown.find('.owl-dropdown-menu').removeClass('active');
            }
        }
    });
    jQuery('.mobilenav-inner li').each(function() {
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="13.017" height="8.41" viewBox="0 0 13.017 8.41"><g transform="translate(-1801.59 -1416.09)"><path d="M0,0,5.1,6l5.1-6" transform="translate(1803 1417.5)" fill="none" stroke="#27241d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>';
        if (jQuery(this).children('ul').length != 0) {
            jQuery(this).addClass('has-sub');
            jQuery(this).children('a').wrap('<div class="has-sub-toggle"></span>');
            jQuery(this).children('.has-sub-toggle').append('<span class="toggle-mobilenav-sub">' + svg + '</span>');
        }
    });
    jQuery(document).on('click', '.toggle-mobilenav-sub', function() {
        jQuery(this).toggleClass('active');
        jQuery(this).closest('.has-sub').children('ul').slideToggle();
    });
















  
});


//--WINDOW RESIZE FUNCTION BEGIN
jQuery(window).resize(function() {
  mobilenav_height();
  owl_card_list_slider();
  owl_card_info_slider();
});
jQuery(window).scroll(function() {
  if(jQuery('#shopify-section-bf_topbar').length != 0){
    let height = jQuery('#shopify-section-bf_topbar').height();
    let fromTop = $(this).scrollTop();
    if(fromTop > height){
      jQuery('#mobilenav-main').css('top', 0);
      jQuery('#mobilenav-main').css('height', '100vh');      
    }else{
        jQuery('#mobilenav-main').css('top', height);
        jQuery('#mobilenav-main').css('height', `calc(100vh - ${height}px)`);
      }    
  }

});  